import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgNeu = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M10.156 14.467v-4.465H9.114v1.82c0 .289.006.53.012.634h-.012a6 6 0 0 0-.271-.555L7.77 10.002h-.993v4.465h1.042v-1.912c0-.284-.012-.555-.012-.617h.012c.037.087.123.29.271.555l1.11 1.974zM13.254 14.467v-1.024H12.02v-.71h1.086v-.998H12.02v-.71h1.234v-1.023h-2.442v4.465zM17.048 13.098v-3.096h-1.234v3.108c0 .234-.166.37-.376.37s-.376-.136-.376-.37v-3.108H13.83v3.096c0 .93.684 1.43 1.61 1.43.924 0 1.609-.5 1.609-1.43"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgNeu;
